import 'keen-slider/keen-slider.min.css'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import { RectShape } from 'react-placeholder/lib/placeholders'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import useCurrentWidth from 'src/hooks/useCurrentWidth'
import { Filter } from 'src/store/reducers/eventFilters'
import { EventFilters, EventType } from '../../Types/Event'
import { LocationsType } from '../../Types/Locations'
import StorySlider from '../Sliders/StorySlider'
import Navigation from './Navigation'
import Search from './Search'
import './styles.scss'
import Carousel from 'react-multi-carousel'
import { CarouselButtonGroup } from '../Carousel/Carousel'
import ManagersService from 'src/api/Managers'

interface HeaderProps {
  userId: number | null
  title?: string
  backgroundImage?: string
  hasSearch?: boolean
  hasSlider?: boolean
  isNavTransparent?: boolean
  isTall?: boolean
  images?: Array<string>
  backgroundImages?: Array<string>
  event?: EventType
  customerId?: string
  hubId?: string
  currentLocation?: LocationsType
  className?: string
  placeholder?: boolean
  filter: (filters: Partial<EventFilters>) => void
  hasCtaGG?: boolean
  stayTransparentSticky?: boolean
  goBackToRoute?: string
  hasSponsors?: boolean
  includeURLSearch?: boolean
  hideBanner?: boolean
}

const Header = React.forwardRef((props: HeaderProps, ref: any) => {
  const [ggEventUrl, setGGEventUrl] = useState('')
  const [ggHubUrl, setGGHubUrl] = useState('')

  const carouselRef = useRef(null)
  let history = useHistory()
  const isEventPreview = ['/preview-event', '/test', '/iframe'].some((route) =>
    history.location.pathname.includes(route),
  )
  const isHubPreview = ['/preview-hub'].some((route) => history.location.pathname.includes(route))

  const handleSearch = (value) => {
    props?.filter({ ...value })
    history.push('/events')
  }
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [])

  let width = useCurrentWidth()

  const responsiveStyle = {
    desktop: {
      breakpoint: { max: 99999, min: 0 },
      items: 1,
    },
  }

  const next = () => {
    if (carouselRef.current) carouselRef.current.next()
  }

  const previous = () => {
    if (carouselRef.current) carouselRef.current.previous()
  }

  const heightClass = props.hasSponsors ? 'not-full-height' : 'h-screen'

  useEffect(() => {
    if (props.userId && props?.event?.id) {
      ManagersService.getByEventId(props.event.id, props.userId).then((res) => {
        setGGEventUrl(res?.gg_event_url)
        setGGHubUrl(res?.gg_hub_url)
      })
    } else if (props.userId && props?.hubId) {
      ManagersService.getByEncryptedHubId(props.hubId, props.userId).then((res) => {
        setGGEventUrl(res?.gg_event_url)
        setGGHubUrl(res?.gg_hub_url)
      })
    }
  }, [props.userId, props?.event?.id, props?.hubId])

  return (
    <Fragment>
      <header
        ref={ref}
        className={`golf-header ${!props.hasSlider && !props.isTall && !props.backgroundImage ? 'has-nav-only' : ''} ${
          props.isTall ? 'is-full-height' : ''
        } ${props.className ? props.className : ''} ${props.hasSponsors && !isHubPreview ? 'reduce-height' : ''}`}>
        {!isEventPreview && (
          <Navigation
            isTransparent={props.isNavTransparent}
            hasCtaGG={props.hasCtaGG}
            stayTransparentSticky={props.stayTransparentSticky}
            goBackToRoute={props.goBackToRoute ?? ''}
            includeURLSearch={props?.includeURLSearch}
            customerId={props.customerId || props?.event?.customer_id}
          />
        )}
        {(ggEventUrl || ggHubUrl) && (
          <div className="admin-banner">
            {ggEventUrl && (
              <>
                <div className="admin-banner__description">
                  Only managers can see this message or make changes to this page. If you want to edit this page, click
                  here:
                </div>
                <a href={ggEventUrl} target="_blank" rel="noreferrer" className="admin-banner__edit-btn">
                  <div className="font-bold">Edit Event</div>
                </a>
              </>
            )}
            {ggHubUrl && (
              <>
                <div className="admin-banner__description">
                  Only managers can see this message or make changes to this Hub. If you want to edit this Hub, click
                  here:
                </div>
                <a href={ggHubUrl} target="_blank" rel="noreferrer" className="admin-banner__edit-btn">
                  <div className="font-bold">Edit Hub</div>
                </a>
              </>
            )}
          </div>
        )}
        {!props?.hideBanner && (
          <div className={'golf-container'}>
            {!props.hasSlider && props.backgroundImage && (
              <figure
                className={'golf-header__singleImage mt-0 sm_tablet:mt-24'}
                style={{ backgroundImage: `url(${props.backgroundImage})` }}></figure>
            )}
            {props.hasSlider && props?.images.length > 0 && (
              <>
                {!loading && (
                  <StorySlider
                    images={props?.images}
                    className={'golf-header__storySlider mt-0 sm_tablet:mt-24'}
                    placeholder={props.placeholder}
                  />
                )}
                {loading && (
                  <RectShape
                    className="golf-header__storySlider mt-0 sm_tablet:mt-24"
                    color="#E0E0E0"
                    style={{
                      width: width < 768 ? '100vw' : '100%',
                      height: width < 1024 ? '200px' : '240px',
                      marginRight: 0,
                    }}
                  />
                )}
              </>
            )}
            {props.backgroundImages && (
              <div
                className={`${
                  isHubPreview ? (props.hasSponsors ? 'preview-reduced-height' : 'preview-height') : ''
                } landing-carousel absolute tw-top-0 tw-left-0 -tw-z-1000`}>
                <Carousel
                  ref={carouselRef}
                  arrows={false}
                  responsive={responsiveStyle}
                  autoPlay
                  autoPlaySpeed={5000}
                  className={`w-screen fix-carousel-width ${isHubPreview ? 'h-full' : heightClass}`}
                  sliderClass={`${isHubPreview ? 'preview-height' : heightClass}`}
                  customTransition="transform 1000ms ease-in-out"
                  transitionDuration={1000}
                  infinite={props.backgroundImages.length > 1}
                  draggable={false}
                  renderButtonGroupOutside={false}
                  pauseOnHover={false}
                  swipeable={false}>
                  {props.backgroundImages.map((backgroundImage, index) => (
                    <img
                      className={`${
                        isHubPreview ? 'preview-height' : heightClass
                      } tw-object-cover set-max-width-images`}
                      key={index}
                      src={backgroundImage}
                    />
                  ))}
                </Carousel>
              </div>
            )}
          </div>
        )}
        {(props.title || props.hasSearch) && (
          <div className={'golf-container mt-auto'}>
            {props.title && <h1 className="mb-80 sm_tablet:mb-120 sm_desktop:mb-104">{props.title}</h1>}
            {props.hasSearch && <Search currentLocation={props.currentLocation} handleSearch={handleSearch} />}
          </div>
        )}
      </header>
    </Fragment>
  )
})

const mapStateToProps = (state) => {
  return {
    userId: state.userReducer.user?.id,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    filter: (filters: Partial<EventFilters>) => dispatch(Filter(filters)),
  }
}

Header.displayName = 'Header'

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Header)
